import { parseSearchQuery, removeWrappingQuotes } from 'utils/stringFunctions';

const splitItems = (arr, character) => {
  let separatedWords = [];
  arr
    .filter((item) => !!item)
    .forEach((item) => {
      let arr = parseSearchQuery(item, character);
      if (arr.length > 1) {
        arr.forEach((word) => {
          if (word.trim() !== '') {
            separatedWords.push(removeWrappingQuotes(word));
          }
        });
      } else {
        separatedWords.push(removeWrappingQuotes(item));
      }
    });
  return separatedWords;
};

export default splitItems;
